import React from "react";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import { Container } from "react-bootstrap";
import ApplicationFormComponent from "../../components/ApplicationFormComponent";

const StrongerVeteransPage = () => {
  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          <PublicNavbar />
          <div className="content">
            <div className="mb-5"></div>
            <Container fluid className="mobilePadding-0">
              <ApplicationFormComponent />
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default StrongerVeteransPage;
